import React from "react";
import { Outlet } from "react-router-dom";

function Ocr() {
  return <Outlet />;
}

export default Ocr;
